import React, { Component } from 'react';
import { Checkbox} from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { TabView,TabPanel } from 'primereact/tabview';
import OrgService from '../../../service/OrgService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { DataView } from 'primereact/dataview';
import { DataTable} from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Steps } from 'primereact/steps';
import { ProgressBar } from 'primereact/progressbar';
import { Messages } from 'primereact/messages';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import CmsService from '../../../service/CmsService';
import { itemTypes } from '../../common/const';
import { QuePreview } from './QuePreview';
import { Panel } from 'primereact/panel';
import CatService from '../../../service/CatService';
import { useTranslation } from 'react-i18next';

const stepItems = [
    {label: 'File Upload'},
    {label: 'Progress'},
    {label: 'Finish'}
];
const questionPatterns = ['###','##','-----','*****'];
const optionPatterns = ['@','#','A)','A@'];
const dataLinePatterns = ['answer','answer_diff','answer_topic','answer_topic_diff'];
const optionCounts = [2,3,4,5,6,7,8,9,10];

export function QueImportWizardLink()
{
    const {t}=useTranslation();
    var {id} = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();
    return <QueImportWizard id={id} docType={searchParams.get('docType')} nav={navigate} t={t}/>
}
export class QueImportWizard extends Component
{
   constructor(props) {
		super(props);
        this.messages = React.createRef();
        this.state={cat:{},loadData:{questionPattern:'##',dataLinePattern:'answer diff',optionPattern:'@',itemType:'MC',options:4},
            page:0,onProgress:false};
		console.log('QueImportWizard:props='+JSON.stringify(props));
    }
    onGetCourse=()=>{
        CatService.getCat(this.props.id).then((res)=>{
            this.setState({cat:res.data});
        });
    }
    dataLinePatterns=()=>{
        return dataLinePatterns.map((p)=>{return {label:this.props.t('ImportDataPattern.'+p),value:p}});
    }
    componentDidMount()
    {
    }
	componentDidUpdate(prevProps, prevState) {
        if(prevProps.id!=this.props.id)
            this.onGetCourse();
	}	    
    componentWillUnmount()
    {
        clearInterval();
    }
    uploadHandler=(event)=>{
        console.log(event.files);
        var loadData = this.state.loadData;
        loadData.file = event.files[0];
    }
    onValChange=(e)=>{
		var prc = this.state.loadData;
		prc[e.target.id]=e.target.value;
		this.setState({loadData:prc});
	}
    progressHandle=(e)=>{
        this.setState({progress:e.loaded*100.0/e.total});
        console.log("uploadProgress:"+e.loaded+"/"+e.total);
    }
    updateProgress(proc)
    {
        if(proc.status == 'OK')
        {
            this.setState({proc:proc,onProgress:false,workCompleted:proc.workCompleted});
            clearInterval(this.interval);
            this.props.nav('/itembank/imports/'+this.state.proc.id);
        }
        else
            this.setState({proc:proc,onProgress:true,workCompleted:proc.workCompleted});
    }
    onPrev=(e)=>{
        this.setState({page:this.state.page-1});
    }
    onNext=(e)=>{
        if(this.state.page == 0 && this.props.docType=='doc')
        {            
            CmsService.importQuestions(this.props.id,this.state.loadData,this.progressHandler).then((ret)=>{
                this.updateProgress(ret);
                this.setState({page:1});
                this.setState({onProgress:true,progress:0});
                this.interval = setInterval(()=>{
                    CmsService.getProc(this.state.proc.id).then((ret)=>{
                        console.log('getProc:'+JSON.stringify(ret));
                        this.setState({progress:Math.round(ret.workCompleted*100.0/ret.totalWork)});
                        this.updateProgress(ret);
                    });
                },350);
            }).catch((err)=>{
                console.log("err:"+err);
                this.showError(err);
            });
        }
        else if(this.state.page == 0 && this.props.docType=='image')
        {            
            CmsService.importQuestionsFromImageSource(this.props.id,this.state.loadData,this.progressHandler).then((ret)=>{
                this.props.nav('/itembank/addquefromimg/'+this.props.id+'?procId='+ret.id+'&questionType='+this.state.loadData.itemType);
            }).catch((err)=>{
                console.log("err:"+err);
                this.showError(err);
            });
        }    
    }
    emptyTemplate=()=>{
        return (
            <div className="flex align-items-center flex-col">
                <span style={{'fontSize': '1.2em', color: 'var(--text-color-secondary)'}} className="my-5">{this.props.t('Drag_and_drop_file_here')}</span>
            </div>
        )
    }    
    displayValueTemplate=(value)=>{
        return (
            <React.Fragment>
                Processing : {value} <b>%</b>
            </React.Fragment>
        );
    }    
    showError=(err) => {
		this.messages.current.show({ severity: 'error', summary: this.props.t('error'), detail: this.props.t('@error.'+err)});
	}	
    itemTypes=()=>{
        return itemTypes.map((item)=>{return {label:this.props.t('QuestionType.'+item.value),value:item.value}});
    }
	render()
	{
        const chooseOptions = {label: this.props.t('Choose'), icon: 'pi pi-fw pi-plus'};
        const uploadOptions = {};
        const cancelOptions = {};

        const buttonCls = 'p-button-secondary mr-2';
        const prev = buttonCls + (this.state.page == 1? '':' hidden');
        const next = buttonCls + (this.state.page < 1? '':' hidden');
        const finish = buttonCls + (this.state.page == 1? '':' hidden');
        const footer = <span>
            <Button label={this.props.t('Previous')} icon="pi pi-chevron-left" className={prev} onClick={this.onPrev} disabled={this.state.page<=1 || this.state.onProgress}/>
            <Button label={this.props.t('Next')} icon="pi pi-chevron-right" loading={this.state.onProgress} className={next} onClick={this.onNext} disabled={this.state.onProgress}/>
            <Button label={this.props.t('Finish')} icon="pi pi-flag" className={finish} onClick={this.onNext} disabled={this.state.onProgress}/>
            </span>;   
        
        const title = <div className="flex justify-content-between"><div><h4>{this.props.t('Import_Questions')}</h4></div><div><h4>{this.state.cat.name}</h4></div></div>
		return(
        <div className='col-12 xl:col-8'>
        <Card footer={footer} title={title}>
        <Messages ref={this.messages}></Messages>
        <ProgressBar value={this.state.progress}  className={"mb-4 " + (this.state.onProgress?"":"hidden")} displayValueTemplate={this.displayValueTemplate}/>        
		<TabView activeIndex={this.state.page} renderActiveOnly onTabChange={(e) => this.setState({page:e.index})}>
        <TabPanel header={this.props.t('File_Selection')} headerTemplate={<></>}>
            <div className="formgrid grid">
                <div className="field col-12 mr-4 mt-4">
                    <label htmlFor="file">{this.props.t('Select_file_to_upload_RTF_ODF')}</label>
                    <FileUpload name="file" mode="advanced" auto
                        multiple={false} emptyTemplate={this.emptyTemplate} chooseOptions={chooseOptions} 
                        uploadOptions={uploadOptions} cancelOptions={cancelOptions} customUpload uploadHandler={this.uploadHandler}></FileUpload>
                </div>
                <div className="field col-6 xl:col-4">
                    <label htmlFor="itemType">{this.props.t('Question_Type')}</label>
                    <Dropdown id="itemType" inputId="itemType" className="w-full" value={this.state.loadData.itemType} options={this.itemTypes()} 
                        onChange={this.onValChange} placeholder={this.props.t('Select_question_type')}/>
                </div>
                <div className="field col-6 xl:col-4">
                    <label htmlFor="options">{this.props.t('Options')}</label>
                    <Dropdown id="options" inputId="options" className="w-full" value={this.state.loadData.options} options={optionCounts} 
                        onChange={this.onValChange} placeholder={this.props.t('Select_option_count')}/>
                </div>
                {
                    this.props.docType=='image'?<></>:
                    <>
                        <div className="field col-6 xl:col-4">
                            <label htmlFor="questionPattern">{this.props.t('Question_pattern')}</label>
                            <Dropdown id="questionPattern" inputId="questionPattern" className="w-full" editable
                                value={this.state.loadData.questionPattern} options={questionPatterns} 
                                onChange={this.onValChange} placeholder={this.props.t('Select_question_pattern')}/>
                        </div>
                        <div className="field col-6 xl:col-4">
                            <label htmlFor="optionPattern">{this.props.t('Option_pattern')}</label>
                            <Dropdown id="optionPattern" inputId="optionPattern" className="w-full" editable
                                value={this.state.loadData.optionPattern} options={optionPatterns} 
                                onChange={this.onValChange} placeholder={this.props.t('Select_option_pattern')}/>
                        </div>
                        <div className="field col-6 xl:col-4">
                            <label htmlFor="dataLinePattern">{this.props.t('Question_data_pattern')}</label>
                            <Dropdown id="dataLinePattern" inputId="dataLinePattern" className="w-full"
                                value={this.state.loadData.dataLinePattern} options={this.dataLinePatterns()} 
                                onChange={this.onValChange} placeholder={this.props.t('Select_data_pattern')}/>
                        </div>                    
                    </>
                }                
            </div>
        </TabPanel>
        <TabPanel header={this.props.t('Progress')} headerTemplate={<></>}></TabPanel>
        </TabView>
        </Card>
        </div>
		);
	}
}
export default QueImportWizard;